import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { formatDate } from '../../../common/utils';
import ReferralChoice from './choice';
// import Find from '../../Contact/Find';
// import New from '../../Contact/New';

import '../modals.css';

const AddReferral = ( { aid, uid, cid, pStatus, pSource, pPurpose } ) => {
    const [ showFind, setShowFind ] = useState( false );
    const [ showNew, setShowNew ] = useState( false );
    const [ data, setData ] = useState( { } );
    
    const show = ( type ) => {
        switch ( type ) {
            case 'find':
                setShowFind( true );
                setShowNew( false );
                break;

            case 'new':
                setShowFind( false );
                setShowNew( true );
                break;

            default:
                console.log( 'Unknown show type!', type );
        }
    }
    
    useEffect( () => {
        const today = new Date();
        setData( {
            ...data,
            createdDate: formatDate( today )
        } );
        // setPurpose( pPurpose.find( p => p.default ).value );
        // setSource( pSource.find( p => p.default ).value );
        // setStatus( pStatus.find( p => p.default ).value );
    }, [ pPurpose, pSource, pStatus ] );

    const create = async () => {
        alert( 'creating referral' );
        // await cg( { aid: aid, uid: uid, name: search, contacts: contacts } );
        // alert( 'done' );
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New Referral Connection</Col>
                </Row>
                <ReferralChoice show={show} />
                {
                    showFind ? (
                        <Fragment />
                    ) : (
                        <Fragment />
                    )
                }
                {
                    showNew ? (
                        <div>New...</div>
                    ) : (
                        <Fragment />
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    cid: state.contacts.current.details.cid,
    pStatus: state.user.meta.global.picklist.status,
    pSource: state.user.meta.global.picklist.source,
    pPurpose: state.user.meta.global.picklist.purpose,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddReferral );